import { z } from 'zod';

import {
  ZodBOExternalAdminUser,
  ZodBoExternalRoleDefinitions,
} from '@Common/types/bo_external/auth/admin_user';
import { endpoint, GetEndpointType } from '@Common/types/zod/zod-endpoint';
import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const ZodBOExternalCompanyBasicInfo = z.object({
  id: z.number().int(),
  name: ZodTrimmedString,
  logo_url: ZodTrimmedString.nullable(),
  is_international: z.boolean(),
  has_indirect_management_contract: z.boolean(),
  start_fiscal_year: ZodTrimmedString,
  retirement_age: z.number().int().nullable(),
});

export type BOExternalCompanyBasicInfo = z.TypeOf<typeof ZodBOExternalCompanyBasicInfo>;

export const ZodBOExternalUserIdentity = z.object({
  user: ZodBOExternalAdminUser,
  role_definitions: ZodBoExternalRoleDefinitions,
  contract_availability: z.object({
    has_er_contracts: z.boolean(),
    has_es_or_soles_contracts: z.boolean(),
  }),
  companies: z.array(ZodBOExternalCompanyBasicInfo),
});

export type BOExternalUserIdentity = z.TypeOf<typeof ZodBOExternalUserIdentity>;

export const getAuthIdentityEndpoint = endpoint({
  method: 'GET',
  responseBody: ZodBOExternalUserIdentity,
});

export type GetAuthIdentityEndpoint = GetEndpointType<typeof getAuthIdentityEndpoint>;

// better-auth doesn't type the 2FA-required fields it adds to a sign-in response
export const ZodBOExternalTwoFactorSignInData = z.object({
  twoFactorRedirect: z.boolean(),
});
